import React from "react";
import ReactDOM from "react-dom/client";
import { Navigate } from "react-router-dom";
import "./index.css";
import { RouterProvider, createHashRouter } from "react-router-dom";
import ModuleLayout from "./layout/ModuleLayout";
import ModuleController from "./controller/ModuleController";
import PublicLayout from "./layout/PublicLayout";
import { initialize } from "./database/core/dbInitializer";
import LoginView from "./views/LoginView";
import AboutView from "./views/AboutView";
import FAQView from "./views/FAQView";
import ReleasesView from "./views/ReleasesView";

async function init() {
  try {
    await initialize();
  } catch (error) {
    console.error("Initialization failed:", error);
  }
}

init();

const router = createHashRouter([
  {
    path: "/",
    element: <PublicLayout />,
    children: [
      { index: true, element: <LoginView /> },
      { path: "about", element: <AboutView /> },
      { path: "faq", element: <FAQView /> },
      { path: "releases", element: <ReleasesView /> },
      { path: "*", element: <Navigate to="/" /> },
    ],
  },
  {
    path: "modules/:moduleName",
    element: <ModuleLayout />,
    children: [
      { index: true, element: <ModuleController /> },
      { path: "*", element: <Navigate to="/" /> },
    ],
  },
  { path: "*", element: <Navigate to="/" /> },
]);

ReactDOM.createRoot(document.getElementById("root")).render(<RouterProvider router={router} />);
